import {
	Component,
	ComponentFactoryResolver,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { MediasService } from "../../../../services/medias.service";
import { CategoryService } from "../../../../services/category.service";
import {
	EventModel,
	EventSubscriptionType,
	EventType,
} from "../../../../shared/interfaces/event.model";
import { DynamicHostModel } from "../../../../shared/modal/models/dynamic-host.model";
import { Subject } from "rxjs";
import { BsModalService } from "ngx-bootstrap/modal";
import { BroadcastService } from "../../../../shared/services/broadcast.service";
import { takeUntil } from "rxjs/operators";
import { NRModalService } from "../../../../shared/modal/services/nrmodal.service";
import { SwalService } from "../../../../shared/services/swal.service";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ModalSize } from "../../../../shared/modal/models/modal.model";
import { CustomersService } from "../../../../services/customers.service";
import { ControlService } from "../../../../services/control.service";
import { MediaViewsService } from "../../../../services/media-views.service";
import { MediaRanking } from "../media/models/media-ranking";

@Component({
	selector: "app-media-kpi",
	templateUrl: "./media-kpi.component.html",
	styleUrls: ["./media-kpi.component.scss"],
})
export class MediaKpiComponent implements OnInit, OnDestroy {
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}
	canAddMedia: boolean = false;
	clientes: any[] = [];
	selectedClientId: number | null = null;
	medias: any;
	rankingMedias: MediaRanking[] = [];
	today = new Date();
	sortOptions: any;
	sortOrder: number;
	clientesMap = new Map<number, string>();
	sortField: string;
	searchName: string = "";
	isAdmin: boolean = false;
	categories: any[] = [];
	hoveredCard: number | null = null;
	selectedNumberRanking: number | null = null;
	ref: DynamicDialogRef | undefined;
	paginationData: any = {
		current_page: 1,
		from: 1,
		last_page: 0,
		per_page: 0,
		to: 0,
		total: 0,
	};

	currentMonth = new Date().toLocaleString("es-MX", { month: "long" });
	private atComponentDestroy = new Subject();

	constructor(
		private mediaService: MediasService,
		private mediaviewService: MediaViewsService,
		public modalRef: BsModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcast: BroadcastService,
		private nrModal: NRModalService,
		private swal: SwalService,
		public dialogService: DialogService,
		private categoryService: CategoryService,
		private customersService: CustomersService,
		private controlservice: ControlService
	) {}

	async ngOnInit(): Promise<void> {
		this.controlservice.isAdmin().subscribe((res) => {
			this.isAdmin = res.is_admin;
		});
		this.customersService.getLimits().then((res: any) => {
			const mediaLimit = res.media || { used: 0, limit: 0 };
			this.canAddMedia = mediaLimit.used < mediaLimit.limit;
		});
		const prueba = await this.mediaviewService.getRankingMedias(10);
		this.rankingMedias = prueba;

		this.customersService.datatable(1, {}).subscribe((res: any) => {
			if (res?.data) {
				res.data.forEach((cliente) => {
					this.clientesMap.set(
						cliente.id,
						cliente.nombre_comercial ?? cliente.name
					);
				});
				this.clientes = res.data;
			}
		});
		this.updateDataTable(10);

		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				if (props) {
					this.nrModal.open(props);
				}
			});

		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.DATATABLE)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				this.updateDataTable(1);
			});

		this.sortOptions = [
			{ label: "Price High to Low", value: "!price" },
			{ label: "Price Low to High", value: "price" },
		];

		this.categories = [
			{ id: 10, name: "10" },
			{ id: 20, name: "20" },
			{ id: 30, name: "30" },
			{ id: 40, name: "40" },
			{ id: 50, name: "50" },
		];
		// 	this.categoryService.datatable().subscribe((res: any) => {
		// 		this.categories = res.data || res;
		//   console.log(this.categories)
		// 	});
	}

	isCurrent(media): boolean {
		return new Date(media.vigencia) >= this.today;
	}

	getClientName(clientId: number | null): string {
		if (!clientId) return "Cliente no asociado";
		return this.clientesMap.get(clientId) || "Cliente no asociado";
	}
	applyFilters(): void {
		const filters: any = {};

		if (this.selectedNumberRanking) {
			filters.numberRanging = this.selectedNumberRanking;
		}
		this.updateDataTable(10, filters);
	}
	getExtraCategoriesTooltip(categories: any[]): string {
		if (!categories || categories.length <= 1) return "";
		return categories
			.slice(2)
			.map((c) => c.name)
			.join(", ");
	}
	getDynamicCardStyle(categoryCount: number): { [key: string]: string } {
		const baseHeight = 450;
		const extraHeight = Math.ceil(categoryCount / 2) * 300;
		const totalHeight = baseHeight + (categoryCount > 1 ? extraHeight : 0);
		return {
			"max-height": `${totalHeight}px`,
		};
	}
	getRankingIndex(mediaId: number): number {
		return this.rankingMedias.findIndex((m) => m.id === mediaId) + 1;
	}
	formatDate(dateString: string): string {
		if (!dateString) return "";
		const date = new Date(dateString);
		return `${date.getDate().toString().padStart(2, "0")}/${(
			date.getMonth() + 1
		)
			.toString()
			.padStart(2, "0")}/${date.getFullYear()}`;
	}
	clearFilters(): void {
		this.selectedNumberRanking = 10;
		this.selectedClientId = null;
		this.searchName = "";
		this.updateDataTable(1);
	}
	toggleExpand(mediaId: number): void {
		if (this.hoveredCard === mediaId) {
			this.hoveredCard = null;
		} else {
			this.hoveredCard = mediaId;
		}
	}

	updateDataTable(numberRanking: number, options: any = {}): void {
		this.mediaService
			.datatable(numberRanking, options)
			.subscribe((data: any) => {
				this.medias = data.data;
				delete data.data;
				delete data.links;
				this.paginationData = data;
			});
	}
	forceReload(): void {
		this.selectedNumberRanking = 10;
		this.updateDataTable(10);
	}
	/**
	 * Update fields on sort column update
	 * @param event
	 */

	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel();
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data || {},
		};

		switch (event.name) {
			// case 'media.export':
			//   props.modalModel.component = ExportReportComponent;
			//   props.modalModel.modalConfiguration = {
			//     title: 'Exportar Reporte',
			//     modalSize: ModalSize.MD
			//   };
			//   break;

			case "media.delete":
				return false;
		}

		return props;
	}

	/**
	 * Get confirmation from the user for deleting and send the signal to the server
	 * @param data
	 */

	/**
	 * Open the modal window to export the xls file
	 * @param data
	 */

	/**
	 * Open modal window
	 */
	openModal(): void {
		this.broadcast.fire({
			name: "media.add",
			type: EventType.MODAL,
			data: { IsAdmin: this.isAdmin, item: {} },
		});
	}

	/**
	 * Open a modal window with the video
	 * @param media
	 */

	/**
	 * Alias function to refresh the medias table
	 *
	 * @param event
	 */
	getMedias(event): void {
		const filters: any = {};

		if (this.selectedNumberRanking) {
			filters.category_id = this.selectedNumberRanking;
		}
		this.updateDataTable(event.page + 1, filters);
	}
}
